import { handleCall } from './handleResponse'
export const technicianService = {
  insert,
  update,
  getAll,
  remove,
}

function remove(technicianId) {
  return handleCall(`/technicians/v1/Technicians/${technicianId}`, {
    method: 'DELETE',
    body: null,
  })
  // var requestOptions = {
  //   method: "DELETE",
  //   headers: authHeader(),
  //   redirect: "follow",
  // };

  // return fetch(
  //   `${stringConstants.URL_ApiGateway}/technicians/v1/Technicians/${technicianId}`,
  //   requestOptions
  // ).then(handleResponse);
}
function getAll(operatorId) {
  const filter = operatorId
    ? `?field=SharingOperatorId&value=${operatorId}`
    : ''
  return handleCall(`/technicians/v1/Technicians${filter}`, {
    method: 'GET',
    body: null,
  })
  // var requestOptions = {
  //   method: "get",
  //   headers: authHeader(),
  //   redirect: "follow",
  // };

  // const filter = operatorId
  //   ? `?field=SharingOperatorId&value=${operatorId}`
  //   : "";
  // return fetch(
  //   `${stringConstants.URL_ApiGateway}/technicians/v1/Technicians${filter}`,
  //   requestOptions
  // ).then(handleResponse);
}

function update(body) {
  const technicianId = body.technicianId
  delete body.technicianId
  return handleCall(`/technicians/v1/Technicians/${technicianId}/Update`, {
    method: 'PUT',
    body: JSON.stringify(body),
  })
  // var requestOptions = {
  //   method: "PUT",
  //   headers: authHeader(),
  //   body: JSON.stringify(body),
  //   redirect: "follow",
  // };

  // return fetch(
  //   `${stringConstants.URL_ApiGateway}/technicians/v1/Technicians/${technicianId}/Update`,
  //   requestOptions
  // ).then(handleResponse);
}

function insert(body) {
  return handleCall(`/technicians/v1/Technicians/New`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
  // var requestOptions = {
  //   method: "POST",
  //   headers: authHeader(),
  //   body: JSON.stringify(body),
  //   redirect: "follow",
  // };

  // return fetch(
  //   `${stringConstants.URL_ApiGateway}/technicians/v1/Technicians/New`,
  //   requestOptions
  // ).then(handleResponse);
}

// function handleResponse(response) {
//   return response.text().then((text) => {
//     if (response.status === 204 || response.status === 404) {
//       return [];
//     }
//     const data = text && JSON.parse(text);
//     if (!response.ok) {
//       if (response.status === 401) {
//         var refreshToken = loginService.getWithExpiry("refresh_token");
//         loginService.refreshToken(refreshToken).then((token) => {
//           loginService.setWithExpiry(
//             "token",
//             token.access_token,
//             token.expires_in
//           );
//         });
//       }
//       const error = (data && data.message) || text;
//       return Promise.reject(error);
//     }

//     // check if the token is close to expire
//     var date = new Date();
//     var now_utc = Date.UTC(
//       date.getUTCFullYear(),
//       date.getUTCMonth(),
//       date.getUTCDate(),
//       date.getUTCHours(),
//       date.getUTCMinutes(),
//       date.getUTCSeconds()
//     );
//     var now = new Date(now_utc);
//     now.setMinutes(now.getMinutes() + 20);
//     var token_expire = new Date(loginService.getWithExpiry("token_dateExpiry"));
//     // if in 10 minutes expire, renew the token
//     if (now > token_expire) {
//       refreshToken = loginService.getWithExpiry("refresh_token");
//       loginService.refreshToken(refreshToken).then((token) => {
//         loginService.setWithExpiry(
//           "token",
//           token.access_token,
//           token.expires_in
//         );
//       });
//     }
//     return data;
//   });
// }
